import * as React from 'react';
import styled from 'styled-components';
import { FieldProps } from 'formik';
import { theme } from '../../theme';

type ToggleTrackDotProps = {
  height: number;
  checked?: boolean;
  disabled?: boolean;
};

const ToggleTrack = styled.div<ToggleTrackDotProps>`
  background-color: ${
    (props: ToggleTrackDotProps): string => props.checked ? theme.colors.putty : theme.colors.paleGrey};
  width: ${(props: ToggleTrackDotProps): number => props.height * 2}px;
  height: ${(props: ToggleTrackDotProps): number => props.height}px;
  border-radius: 35px;
  position: relative;
  display: flex;
  cursor: ${(props: ToggleTrackDotProps): string => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.1s linear 0.1s;
`;

const ToggleDot = styled.div<ToggleTrackDotProps>`
  border-radius: 50%;
  height: ${(props: ToggleTrackDotProps): number => props.height - 4}px;
  width: ${(props: ToggleTrackDotProps): number => props.height - 4}px;
  right: ${(props: ToggleTrackDotProps): number => props.checked ? 0 : props.height}px;
  margin: 2px;
  position: absolute;
  z-index: 1;
  background-color: white;
  transition: all 0.05s linear 0.05s;
  box-shadow: 0 0 10px 0px ${
    (props: ToggleTrackDotProps): string => props.checked ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0,0,0,0.1)'};
`;

type StyledEasyToggleProps = {
  disabled: boolean;
  height?: number;
}

const StyledEasyToggle: React.FunctionComponent<FieldProps & StyledEasyToggleProps> = (props) => {
  const { field: { name, value}, form, disabled, height } = props;
  return (
    <ToggleTrack
      checked={value}
      height={height || 10}
      disabled={disabled}
      onClick={(): void => {
        if (!disabled) {
          form.setFieldValue(name, !Boolean(value));
          form.setFieldTouched(name);
        }
      }}
    >
      <ToggleDot checked={value} height={height || 10} />
    </ToggleTrack>
  );
};

export default StyledEasyToggle;



// WEBPACK FOOTER //
// ./src/components/formElements/StyledEasyToggle.tsx